import {
    emptyDatiqPanelPopup,
    IDatiqPanelPopup,
} from '@dat/datiq-components-pkg/panel-popup';
import { DATIQ_DEFAULT_ID } from '@dat/datiq-core/models';
import { IDatiqCellPopup } from './datiq-cell-popup.interface';
import { emptyDatiqCellLabel } from '../../datiq-cell-label';

export const emptyDatiqCellPopupPanel: IDatiqPanelPopup = {
    ...emptyDatiqPanelPopup,
    closeOnOutsideClick: false,
    closeOnEsc: true,
};
export const emptyDatiqCellPopup: IDatiqCellPopup = {
    id: DATIQ_DEFAULT_ID('cell-popup-panel'),
    panel: { ...emptyDatiqCellPopupPanel },
    label: { ...emptyDatiqCellLabel },
};
